import React from "react";
import styles from "./Page2.module.scss";

const Page2 = () => {
  return (
    <>
      <p>Page2</p>
    </>
  );
};

export default Page2;
